const Theme = {
	purple: '#7289da',
	white: '#f7f7ff',
	halfWhite: '#E5E5E5',
	metallic: '#99aab5',
	lightGrey: '#2c3f33',
	darkGrey: '#23272a',
}

export default Theme;